var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-lab-product-detail',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"labProduct":_vm.labProduct},on:{"goDelete":_vm.goDelete}})}
var staticRenderFns = []

export { render, staticRenderFns }